export default __webpack_public_path__ + "static/media/loading-5.7153f042.jpeg";